<script setup lang="ts">
import { PrimaryButton } from '@/components/Buttons'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'

type Props = {
    label: string
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'click'): void
}
defineEmits<Emits>()
</script>

<template>
    <PrimaryButton
        :disabled="loading"
        class="fit-content place-self-end"
        :label="label"
        @click="$emit('click')"
        v-bind="$attrs">
        <LoadingSpinner :isLoading="!!loading" />
    </PrimaryButton>
</template>
